import React from "react";
import { motion } from "framer-motion";

const Header = ({
  isSticky,
  handleMenuClick,
  isMenuActive,
  activeSection,
  toggleTheme,
  currentTheme,
}) => {
  return (
    <header className={`header ${isSticky ? "sticky" : ""}`}>
      <i
        id="menu-icon"
        className={`bx ${isMenuActive ? "bx-x" : "bx-menu"}`}
        onClick={handleMenuClick}
      ></i>
      <a href="#home" className="logo">
        Portfolio
      </a>

      <div className="header-div">
        <nav className={`navbar ${isMenuActive ? "active" : ""}`}>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="mobile-menu"
          >
            <a
              href="#home"
              className={activeSection === "home" ? "active" : ""}
            >
              Home
            </a>
            <a
              href="#about"
              className={activeSection === "about" ? "active" : ""}
            >
              About Me
            </a>
            <a
              href="#services"
              className={activeSection === "services" ? "active" : ""}
            >
              Services
            </a>
            <a
              href="#portfolio"
              className={activeSection === "portfolio" ? "active" : ""}
            >
              Portfolio
            </a>
            <a
              href="#contact"
              className={activeSection === "contact" ? "active" : ""}
            >
              Contact
            </a>
          </motion.div>
        </nav>
        <div id="theme-toggler-div">
          <div onClick={toggleTheme} className="theme-toggler">
            {currentTheme === "light" ? (
              <>
                <i className="bx bx-moon"></i>
                <h3 className="theme-h3">Dark Mode</h3>
              </>
            ) : (
              <>
                <i className="bx bx-sun"></i>
                <h3 className="theme-h3">Light Mode</h3>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
